import {ApiV0Crm} from '../api.v0.crm';
import {RestApiService} from '../../../rest-api.service';
import {EffortType} from '../../../../contracts/v0/crm';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {map} from 'rxjs';

export class ApiV0CrmEffortType {
    segment = '/effortType'

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    add(create: EffortType) {
        return this.rest.post<EffortType, EffortType>(this.segment, EffortType, create);
    }

    search(model: SearchModel = new SearchModel()) {
        return this.rest.post<SearchModel, BaseCollectionModel<EffortType>>(this.segment + '/search', EffortType, model)
    }

    bulkDelete(ids: string[]) {
       return  this.rest.post<string[],unknown>(this.segment + '/bulkDelete', Object as any, ids).pipe(map(() => undefined));
    }

    update(update: EffortType, id:string) {
       return  this.rest.patch<EffortType, EffortType>(this.segment + `/${id}`, EffortType, update)
    }
}